import React, { useState, useMemo } from "react";
import { FaSearch, FaRegCalendar, FaEye } from "react-icons/fa";
import Footer from "../components/footer/Footer";

// Daftar kategori (bisa juga dari API nanti)
const CATEGORIES = [
  { id: "all", name: "Semua" },
  { id: "pinjaman", name: "Pinjaman" },
  { id: "investasi", name: "Investasi" },
  { id: "keuangan", name: "Keuangan Pribadi" },
  { id: "berita", name: "Berita Perusahaan" },
];

// Mock data artikel dengan kategori
const blogPosts = [
  // {
  //   id: 1,
  //   title: "Cara Mengelola Keuangan Pribadi di Masa Sulit",
  //   excerpt:
  //     "Tips praktis untuk menjaga stabilitas finansial saat kondisi ekonomi sedang tidak menentu.",
  //   date: "26 Okt 2025",
  //   author: "Tim Toko Mikro",
  //   image: "/images/blog1.jpg",
  //   views: 3420,
  //   category: "keuangan",
  // },
  // {
  //   id: 2,
  //   title: "Mengenal Pinjaman Payroll: Solusi Tanpa Ribet untuk Karyawan",
  //   excerpt:
  //     "Pinjaman payroll menawarkan cara praktis dengan cicilan langsung dari gaji bulanan.",
  //   date: "18 Okt 2025",
  //   author: "Budi Santoso",
  //   image: "/images/blog2.jpg",
  //   views: 2890,
  //   category: "pinjaman",
  // },
  // {
  //   id: 3,
  //   title: "Investasi Emas vs Tabungan: Mana yang Lebih Menguntungkan?",
  //   excerpt:
  //     "Perbandingan mendalam antara dua instrumen keuangan populer di kalangan masyarakat.",
  //   date: "10 Okt 2025",
  //   author: "Dewi Lestari",
  //   image: "/images/blog3.jpg",
  //   views: 5120,
  //   category: "investasi",
  // },
  // {
  //   id: 4,
  //   title: "5 Kesalahan Umum Saat Mengajukan Pinjaman Online",
  //   excerpt: "Hindari jebakan yang bisa membuatmu terlilit utang berlebihan.",
  //   date: "02 Okt 2025",
  //   author: "Tim Toko Mikro",
  //   image: "/images/blog4.jpg",
  //   views: 4210,
  //   category: "pinjaman",
  // },
  // {
  //   id: 5,
  //   title: "Cara Cerdas Menabung untuk Liburan Akhir Tahun",
  //   excerpt:
  //     "Strategi menabung bulanan agar liburan akhir tahun tidak mengganggu keuangan.",
  //   date: "29 Sep 2025",
  //   author: "Rina Wijaya",
  //   image: "/images/blog5.jpg",
  //   views: 1870,
  //   category: "keuangan",
  // },
  // {
  //   id: 6,
  //   title: "Toko Mikro Raih Penghargaan Fintech Terbaik 2025",
  //   excerpt:
  //     "Pengakuan atas inovasi dan layanan keuangan inklusif yang kami hadirkan.",
  //   date: "21 Sep 2025",
  //   author: "Tim PR",
  //   image: "/images/blog6.jpg",
  //   views: 6230,
  //   category: "berita",
  // },
];

const BlogPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");

  // Filter berdasarkan kategori + pencarian
  const filteredPosts = useMemo(() => {
    let result = blogPosts;

    // Filter kategori
    if (selectedCategory !== "all") {
      result = result.filter((post) => post.category === selectedCategory);
    }

    // Filter pencarian
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      result = result.filter(
        (post) =>
          post.title.toLowerCase().includes(query) ||
          post.excerpt.toLowerCase().includes(query)
      );
    }

    return result;
  }, [selectedCategory, searchQuery]);

  return (
    <>
      <div className="min-h-screen bg-slate-50">
        {/* Hero Banner */}
        <div className="relative h-72 overflow-hidden bg-[#3f6fe5] [--hero-grid:115px] md:h-80 lg:h-96">
          {/* <img
          src={pola}
          alt="Blog Toko Mikro"
          className="w-full h-full object-cover brightness-75"
          loading="eager"
        /> */}
          <div
            className="pointer-events-none absolute inset-0 opacity-30"
            style={{
              backgroundImage:
                "linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed)",
              backgroundRepeat: "no-repeat",
              backgroundSize:
                "var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid)",
              backgroundPosition:
                "calc(var(--hero-grid) * 3) 0, calc(var(--hero-grid) * 12) 0, calc(var(--hero-grid) * 13.6) var(--hero-grid), calc(var(--hero-grid) * 4) calc(var(--hero-grid) * 3), calc(var(--hero-grid) * 8) calc(var(--hero-grid) * 3)",
            }}
          ></div>
          <div
            className="absolute inset-0 opacity-70"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.28) 2px, transparent 2px), linear-gradient(90deg, rgba(255,255,255,0.28) 2px, transparent 2px)",
              backgroundSize: "var(--hero-grid) var(--hero-grid)",
            }}
          ></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-white drop-shadow-lg md:text-5xl lg:text-6xl">
              Artikel & Berita
            </h1>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-blue-100/90 drop-shadow md:text-lg">
              Temukan wawasan terbaru seputar keuangan, investasi, dan inovasi
              dari Toko Mikro.
            </p>
          </div>
        </div>

        {/* Search & Kategori */}
        <div className="section-shell mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Search Box */}
          <div className="max-w-2xl mx-auto mb-6">
            <div className="flex items-center rounded-2xl border border-slate-200 bg-white p-2 shadow-lg shadow-slate-900/5 transition-all focus-within:border-blue-300 focus-within:ring-4 focus-within:ring-blue-100">
              <FaSearch className="text-gray-400 ml-3" />
              <input
                type="text"
                placeholder="Cari artikel..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-4 py-3 text-slate-700 outline-none placeholder:text-slate-400"
              />
            </div>
          </div>

          {/* Kategori Filter */}
          <div className="flex flex-wrap justify-center gap-2 mb-10">
            {CATEGORIES.map((cat) => (
              <button
                key={cat.id}
                onClick={() => {
                  setSelectedCategory(cat.id);
                  setSearchQuery(""); // opsional: reset pencarian saat ganti kategori
                }}
                className={`rounded-full px-4 py-2 text-sm font-semibold transition-all ${
                  selectedCategory === cat.id
                    ? "bg-[#3f6fe5] text-white shadow-lg shadow-[#3f6fe5]/20"
                    : "border border-slate-200 bg-white text-slate-700 hover:border-[#c9d8ff] hover:bg-[#eef4ff] hover:text-[#2458d3]"
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>

          {/* Daftar Artikel */}
          {filteredPosts.length === 0 ? (
            <div className="rounded-3xl border border-dashed border-slate-300 bg-white px-6 py-16 text-center shadow-sm shadow-slate-900/5">
              <div className="mx-auto mb-4 h-14 w-14 rounded-2xl bg-[#eef4ff] flex items-center justify-center"><FaSearch className="text-[#3f6fe5] text-xl" /></div>
              <p className="text-slate-600 text-lg">
                Tidak ada artikel yang sesuai dengan kategori dan pencarian
                Anda.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <article
                  key={post.id}
                  className="modern-card group overflow-hidden"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <div className="mb-3 flex flex-wrap items-center gap-2 text-sm text-slate-500">
                      <span className="rounded-full bg-[#eef4ff] px-2 py-0.5 text-xs font-medium text-[#2458d3]">
                        {CATEGORIES.find((c) => c.id === post.category)?.name ||
                          "Umum"}
                      </span>
                      <span>•</span>
                      <span className="flex items-center">
                        <FaRegCalendar className="mr-1" />
                        {post.date}
                      </span>
                      <span>•</span>
                      <span className="flex items-center">
                        <FaEye className="mr-1" />
                        {post.views.toLocaleString("id-ID")}
                      </span>
                    </div>

                    <h2 className="mb-2 line-clamp-2 text-lg font-bold text-slate-900 group-hover:text-[#2458d3]">
                      {post.title}
                    </h2>

                    <p className="mb-4 line-clamp-3 text-sm leading-7 text-slate-600">
                      {post.excerpt}
                    </p>

                    <a
                      href={`/blog/${post.id}`}
                      className="inline-block text-[#2458d3] font-medium text-sm hover:underline"
                      aria-label={`Baca artikel: ${post.title}`}
                    >
                      Baca Selengkapnya →
                    </a>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogPage;
